import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { HistoryRouter } from 'redux-first-history/rr6';

import AppRouter from 'AppRouter';
import { ToastContainer } from 'react-toastify';
import store, { reduxHistoryStore } from './store';

import app from './app';
import picsioConfig from '../../../config';

import '../css/singleSharing.scss';

picsioConfig.access = window.websiteConfig;

(async () => {
  await app.startSingleApp();
  const container = document.querySelector('.wrapperPicsioApp');
  const root = createRoot(container);

  root.render(
    <Provider store={store}>
      <HistoryRouter history={reduxHistoryStore}>
        <AppRouter />
        <ToastContainer
          position="bottom-right"
          autoClose={10000}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnHover
          pauseOnFocusLoss
          draggable
        />
      </HistoryRouter>
    </Provider>,
  );
})();

window.mapsCallback = () => {
  window.dispatchEvent(new Event('gMapsInited'));
};
